import script from "./ScrollDown.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollDown.vue?vue&type=script&setup=true&lang=js"

import "./ScrollDown.vue?vue&type=style&index=0&id=2d7dde68&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7dde68"]])

export default __exports__